<template>
	<div class="row">
		<div class="col-sm-4 col-sm-offset-4">
			<div class="attach-company">
				<div class="radio-wrapper">
					<input type="radio" id="individual" value="INDIVIDUAL" v-model="selectedCompanyType">
					<label for="individual">{{ $t('individual') }}</label>
				</div>
				<div class="radio-wrapper">
					<input type="radio" id="legal" value="LEGAL" v-model="selectedCompanyType">
					<label for="legal">{{ $t('legal') }}</label>
				</div>
				<div class="radio-wrapper">
					<input type="radio" id="company" value="COMPANY" v-model="selectedCompanyType">
					<label for="company">{{ $t('company.list') }}</label>
				</div>

				<template v-if="!isCompany">
					<hr>
					<div class="input-wrapper">
						<label class="attach-company_label" for="name">
							{{isIndividual ? $t('individual.name') :
							$t('organization.name')}}
							<span class="required">&#9913;</span>
						</label>
						<input list="organizationList" id="name" class="textInput" type="text" @input="changeInput" v-model="orgName"
							   :disabled="isIndividual || isSelectedExistingOrganization"
							   :placeholder="(isIndividual ? $t('individual.name') : $t('organization.name'))">
						<datalist id="organizationList">
							<option v-for="value in organizationList" :key="value.id" :value="value.name">{{ value.name
								}}
							</option>
						</datalist>
						<i class="reset_input fa fa-times" @click="inputReset('orgName')"
						   v-if="!isIndividual && !isSelectedExistingOrganization"/>
					</div>

					<div class="input-wrapper">
						<label class="attach-company_label" for="code">
							{{isIndividual ? $t('personal.code') : $t('register.code')}}
							<span class="required" v-if="!isIndividual">&#9913;</span>
						</label>
						<input id="code" class="textInput" type="text" @input="changeInput" v-model="orgCode"
							   :placeholder="(isIndividual ? $t('personal.code') : $t('register.code'))"
							   :disabled="isSelectedExistingOrganization && !isIndividual">
						<i class="reset_input fa fa-times" @click="inputReset('orgCode')" v-if="!isSelectedExistingOrganization"/>
					</div>
					<!--<div class="attach_messages" v-if="isSelectedExistingOrganization && !isIndividual">
					  <p>Error</p>
					</div>-->

					<div class="input-wrapper"
						 v-if="isSelectedExistingOrganization && !isIndividual && (organizationGroupList.length !== 0)">
						<label class="attach-company_label" for="groups">
							{{ $t('user.groups') }}
							<span class="required">&#9913;</span>
						</label>
						<select name="country" id="groups" v-model="selectedGroupsId">
							<option value="">-</option>
							<option v-for="value in organizationGroupList" :key="value.id" :value="value.id">{{
								value.name }}
							</option>
						</select>
					</div>

					<template v-if="!isSelectedExistingOrganization">
						<template v-if="!isIndividual">
							<div class="input-wrapper">
								<label class="attach-company_label" for="country">
									{{ $t('company.role') }}
								</label>
								<select name="role" id="role" v-model="role">
									<option value="CLIENT">{{ $t('CLIENT') }}</option>
									<option value="BANK">{{ $t('BANK') }}</option>
								</select>
							</div>
							<div class="input-wrapper">
								<label class="attach-company_label" for="valueAddedTax">{{ $t('vatid')
									}}</label>
								<input id="valueAddedTax" class="textInput" v-model="vatid" type="text"
									   :placeholder="$t('vatid')">
								<i class="reset_input fa fa-times" @click="inputReset('vatid')"/>
							</div>
							<div class="input-wrapper">
								<label class="attach-company_label" for="streetAndNumber">{{
									$t('street.and.number') }}</label>
								<input id="streetAndNumber" class="textInput" v-model="streetAndNumber" type="text"
									   :placeholder="$t('street.and.number')">
								<i class="reset_input fa fa-times" @click="inputReset"/>
							</div>
							<div class="input-wrapper">
								<label class="attach-company_label" for="city">{{ $t('city') }}</label>
								<input id="city" class="textInput" v-model="city" type="text"
									   :placeholder="$t('city')">
								<i class="reset_input fa fa-times" @click="inputReset('city')"/>
							</div>
							<div class="input-wrapper">
								<label class="attach-company_label" for="state">{{ $t('state') }}</label>
								<input id="state" class="textInput" v-model="state" type="text"
									   :placeholder="$t('state')">
								<i class="reset_input fa fa-times" @click="inputReset('state')"/>
							</div>
							<div class="input-wrapper">
								<label class="attach-company_label" for="postalCode">{{ $t('postal.code')
									}}</label>
								<input id="postalCode" class="textInput" v-model="postalCode" type="text"
									   :placeholder="$t('postal.code')">
								<i class="reset_input fa fa-times" @click="inputReset('postalCode')"/>
							</div>
						</template>
					</template>

					<div class="input-wrapper" v-if="isIndividual || !isSelectedExistingOrganization">
						<label class="attach-company_label" for="country">
							{{ $t('countries') }}
							<span class="required">&#9913;</span>
						</label>
						<select name="country" id="country" v-model="country">
							<option v-for="(value, key) in data.countries" :key="key" :value="key">{{ $t(value)
								}}
							</option>
						</select>
					</div>


					<button type="button"
							:class="(valid ? 'attach_button' : 'attach_button-disabled')"
							id="attach-button"
							:disabled="(!valid)"
							@click="attach"
							v-if="isIndividual || (!isSelectedExistingOrganization && !isIndividual)">
						{{ $t('create') }}
					</button>
					<button type="button"
							:class="(valid ? 'attach_button' : 'attach_button-disabled')"
							id="attach-button_join"
							:disabled="(!valid)"
							@click="join"
							v-if="isSelectedExistingOrganization && !isIndividual">
						{{ $t('join') }}
					</button>
					<button type="button"
							class="attach_button-secondary"
							id="attach-button_back"
							@click="back"
							v-if="isSelectedExistingOrganization && !isIndividual">
						{{ $t('back') }}
					</button>
				</template>
				<template v-else>
					<template v-if="dataCompanyListForPerson.length === 0">
						<p>No created or connected organizations</p>
					</template>
					<template v-else>
						<table class="table table-bordered">
							<thead>
							<tr>
								<th>{{ $t('company') }}</th>
								<th>{{ $t('group') }}</th>
								<th>{{ $t('confirmed') }}</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="value in dataCompanyListForPerson" :key="value.id"
								:class="value.active ? '' : 'danger'">
								<td>{{ value.company }}</td>
								<td>{{ value.group }}</td>
								<td>
									<i class="fa fa-check success" aria-hidden="true" v-if="value.active"/>
									<i class="fa fa-times danger" aria-hidden="true" v-else/>
								</td>
							</tr>
							</tbody>
						</table>

						<button type="button"
								class="update_button"
								id="update-button"
								@click="updateTable">
							{{ $t('update') }}
						</button>
					</template>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import http from 'utils/http'
import { CONFIGURATIONS_ATTACH_COMPANY } from 'actions/configurations'
import { showMessageAlert } from '@/core/shared'

export default {
	name: 'AttachCompany',
	metaInfo () {
		return {
			title: this.$t('attach.company')
		}
	},
	data () {
		return {
			data: {},
			selectedCompanyType: 'INDIVIDUAL',
			country: 'EE',
			orgName: '',
			personalName: '',
			personalCode: '',
			orgCode: '',
			vatid: '',
			streetAndNumber: '',
			city: '',
			state: '',
			postalCode: '',
			role: 'CLIENT',
			organizationList: [],
			organizationGroupList: [],
			selectedGroupsId: null,
			selectedCompanyId: null,
			registerCodeList: {},
			isExisting: false,
			dataCompanyListForPerson: []
		}
	},
	computed: {
		isIndividual: function () {
			return this.selectedCompanyType === 'INDIVIDUAL'
		},
		isCompany: function () {
			return this.selectedCompanyType === 'COMPANY'
		},
		isSelectedExistingOrganization: {
			get () {
				if (this.organizationList.length === 1) {
					if (this.orgName === this.organizationList[0].name) {
						this.$set(this, 'orgCode', this.organizationList[0].code)
						this.$set(this, 'selectedCompanyId', this.organizationList[0].id)
						this.getGroupOrganization(this.organizationList[0].id)
						return true
					}
				} else if (typeof this.registerCodeList.code !== 'undefined') {
					if (this.orgCode === this.registerCodeList.code) {
						this.$set(this, 'orgName', this.registerCodeList.name)
						this.$set(this, 'selectedCompanyId', this.registerCodeList.id)
						this.getGroupOrganization(this.registerCodeList.id)
						return true
					}
				} else {
					return false
				}
			},
			set (newValue) {
				return newValue
			}
		},
		valid: function () {
			let baseValid = this.name !== '' && this.country !== ''
			if (this.isIndividual) {
				return baseValid
			} else {
				return baseValid && (this.selectedGroupsId !== '') && this.code !== ''
			}
		}
	},
	methods: {
		getData: function () {
			this.data.person = this.$store.getters.getPerson
			this.data.countries = this.$store.getters.getCountries
			this.personalName = this.data.person.firstName + ' ' + this.data.person.lastName
			this.dataCompanyList()
		},
		getCompanyAttachList: function (data) {
			let vm = this
			_.throttle(
				http.post('company/attach/list', {
					'partName': data.name,
					'code': data.code
				}).then(function (res) {
					if (data.code !== null && res.data.length === 1) {
						vm.$set(vm, 'registerCodeList', res.data[0])
					} else if (data.code !== null && res.data.length === 0) {
						vm.$set(vm, 'registerCodeList', {})
					} else {
						vm.$set(vm, 'organizationList', res.data)
					}
				}).catch(function (error) {
					vm.rollbar.error('attach/list', error)
					console.log('attach/list', error)
				}), 1000, data.options)
		},
		attach: function () {
			let vm = this
			let data = {
				'name': this.name,
				'code': this.code,
				'country': this.country,
				'type': this.selectedCompanyType,
				'role': 'CLIENT'
			}
			if (!this.isIndividual) {
				data.streetAndNumber = this.streetAndNumber
				data.city = this.cite
				data.state = this.state
				data.postalCode = this.postalCode
				data.valueAddedTax = this.vatid
				data.role = this.role
			}

			http.post('company/create-with-attach', data)
				.then(function (res) {
					vm.resetData()
					showMessageAlert('success', 'success')
					vm.selectedCompanyType = 'COMPANY'
				})
				.catch(function (error) {
					showMessageAlert('error', 'danger', error.data)
					console.log(error)
					vm.rollbar.error('create-with-attach', error.data)
				})
		},
		join: function () {
			let vm = this
			http.post('user/self-attach', `companyId=${this.selectedCompanyId}&groupId=${this.selectedGroupsId}`, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			})
				.then(function (res) {
					vm.resetData()
					showMessageAlert('success', 'success')
				})
				.catch(function (error) {
					showMessageAlert('error', 'danger', error.response.data)
					vm.rollbar.error('self-attach', error)
				})
		},
		back: function () {
			this.$set(this, 'registerCodeList', {})
			this.$set(this, 'organizationList', [])
			this.$set(this, 'orgCode', '')
		},
		getGroupOrganization: function (id) {
			let vm = this
			http.post('company/groups', 'id=' + id, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			}).then(function (res) {
				vm.$set(vm, 'organizationGroupList', res.data)
			}).catch(function (error) {
				showMessageAlert('error', 'danger', error.response.data)
				vm.rollbar.error('attach company/groups', error)
			})
		},
		updateTable: function () {
			this.dataCompanyList()
			showMessageAlert('list updated', 'success')
		},
		resetData: function () {
			this.$set(this, 'selectedCompanyType', 'INDIVIDUAL')
			this.$set(this, 'country', 'EE')
			this.$set(this, 'orgName', '')
			this.$set(this, 'personalName', this.data.person.firstName + ' ' + this.data.person.lastName)
			this.$set(this, 'personalCode', '')
			this.$set(this, 'orgCode', '')
			this.$set(this, 'vatid', '')
			this.$set(this, 'streetAndNumber', '')
			this.$set(this, 'city', '')
			this.$set(this, 'state', '')
			this.$set(this, 'postalCode', '')
			this.$set(this, 'organizationList', [])
			this.$set(this, 'organizationGroupList', [])
			this.$set(this, 'selectedGroupsId', null)
			this.$set(this, 'selectedCompanyId', null)
			this.$set(this, 'registerCodeList', {})
			this.$set(this, 'isExisting', false)
			this.dataCompanyList()
		},
		inputReset: function (name) {
			this[name] = ''
		},
		dataCompanyList: function () {
			let vm = this
			let userId = vm.data.person.id
			http.post(`individual-person/${userId}/users/ids`, {})
				.then(function (res) {
					http.post(`individual-person/${userId}/users/load`, 'ids=' + JSON.stringify(res.data), {
						headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
					}).then(function (res) {
						vm.dataCompanyListForPerson = res.data
					}).catch(function (error) {
						showMessageAlert('error', 'danger', error.response.data)
					})
				})
				.catch(function (error) {
					showMessageAlert('error', 'danger', error.response.data)
					vm.rollbar.error('attach dataCompanyList', error.response.data)
				})
		},
		changeInput: _.debounce(
			function (event) {
				let newValue = event.target.value
				if (!this.isIndividual) {
					let data = {
						name: newValue,
						code: null,
					}
					if (newValue === '') {
						this.$set(this, 'organizationList', [])
						return
					}
					this.getCompanyAttachList(data)
				}
		}, 500)
	},
	mounted () {
		this.getData()
	}
}
</script>

<style scoped>
	.attach-company button {
		width: 100%;
	}

	.attach-company hr {
		margin: 5px 0;
	}

	.attach-company input[type=text], .attach-company select {
		font-size: 17px;
		height: 40px;
		padding-left: 10px;
		margin-bottom: -1px;
		border: 1px solid #cccccc;
		width: 100%;
		border-radius: 4px;
		color: #666;
	}

	.attach-company_label {
		font-size: 13px;
		margin: 10px 5px 5px;
		color: #666;
	}

	.attach_button, .update_button, .attach_button-secondary, .attach_button-disabled {
		border: none;
		color: #ffffff;
		font-size: 15px;
		height: 30px;
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.attach_button:hover, .update_button:hover {
		background-color: #007eb7;
	}

	.attach_button, .update_button {
		background-color: #0090D0;
	}

	.update_button {
		margin-top: 0;
	}

	.attach_button-disabled {
		background-color: #979797;
	}

	.attach_button-secondary {
		background-color: #fff;
		color: #666;
		border: 1px solid #cccccc;
		margin: 5px 0 0 0;
	}

	.attach_button-secondary:hover {
		background-color: #f7f6f6;
	}

	.radio-wrapper {
		display: inline;
		margin-right: 15px;
	}

	.radio-wrapper label:hover {
		cursor: pointer;
	}

	.input-wrapper {
		position: relative;
	}

	.reset_input {
		position: absolute;
		bottom: 31px;
		font-size: 11px;
		right: -3px;
		color: #A9A9A9;
	}

	.reset_input:hover {
		cursor: pointer;
		color: red;
	}

	.attach_messages p {
		margin: 0;
		color: red;
	}

	.attach_messages span {
		font-style: italic;
		text-decoration: underline;
	}

	.required {
		position: absolute;
		top: 5px;
		margin-left: 3px;
		color: red;
	}

	table {
		margin-top: 10px;
		color: #666;
	}

	th {
		font-weight: 600;
	}

	th, td {
		text-align: center;
	}

</style>
